// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__blNCd","step-link":"Breadcrumbs_step-link__tPfEI","step-icon":"Breadcrumbs_step-icon__a7d27","step-text":"Breadcrumbs_step-text__JAI7B"};